
import ResultGroup from '@/components/resultGroup.vue';

export default {
  name: 'SearchResults',

  components: {
    ResultGroup,
  },

  data() {
    return {
      searchResults: [],
      loading: false,
    };
  },

  computed: {
    query() {
      return this.$route.query.q;
    },
    cat() {
      return this.$route.query.cat;
    },

    category() {
      return this.cat
        ? this.categories.find((c) => c.id === parseInt(this.cat))
        : null;
    },
  },
};
